
import SsrCarousel from 'vue-ssr-carousel'


export default {
  components: { SsrCarousel },
  props:{
    region:{
      type:String,
      default:'uk',
    },
    count: { 
      default: 3, 
      type: Number 
    },
    height: { 
      default: '444', 
      type: String 
    },
    width: { 
      default: '250', 
      type: String 
    },
  },
  data() {
    return {

      isVisible:false
    }
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible
      // console.log(isVisible, entry)
    }
  }
}
